/**
 * Get the prev step id
 *
 * @param {string} newStepId - current step id
 * @returns {string} - prev step id
 */
export function getPrevStepId(newStepId) {
	return document.querySelector(`#${newStepId}`).previousElementSibling.getAttribute('id');
}
